import React from 'react';
import { Typography } from 'antd';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Title } from '~/components';
import paths from '~/pages/paths';
import { useAcceptInvitation, useExistingCompany } from '~/controllers/invitation';
import { useLogout } from '~/controllers/auth';
import { ConfirmButton } from '~/layouts/ksa/CompanyInfoLayout';

const ExistingUser: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation('ksaOnboarding');
  const acceptInvitation = useAcceptInvitation();
  const { handleLogout } = useLogout();
  const [existingCompany] = useExistingCompany();

  const onAcceptClick = () => {
    acceptInvitation
      .mutateAsync()
      .then(() => {
        history.push(paths.home._);
      })
      .catch(() => {
        history.push(paths.ksa.invitation.error.replace(':errorType', 'default'));
      });
  };

  const onSignInClick = () => {
    void handleLogout();
  };

  return (
    <div>
      <Title text={t('Get started')} subtext={t('with {{BRANDING_NAME}}')} />
      <SubTitle>
        {t(
          'We found that your email is already connected to another application process for {{name}}. If you continue with the this application, you lose access to {{name}} application.',
          { name: existingCompany?.legalName }
        )}
      </SubTitle>

      <StyledButton
        id="acceptInvitation_accept"
        type="primary"
        htmlType="submit"
        loading={acceptInvitation.isLoading}
        onClick={onAcceptClick}
      >
        {t('Accept invitation')}
      </StyledButton>
      <StyledButton
        id="acceptInvitation_signin"
        type="default"
        danger
        loading={acceptInvitation.isLoading}
        onClick={onSignInClick}
      >
        {t('Sign in with my application')}
      </StyledButton>
    </div>
  );
};

const StyledButton = styled(ConfirmButton)`
  max-width: unset;
`;

const SubTitle = styled(Typography.Paragraph)`
  margin-bottom: 32px !important;
`;

export default ExistingUser;
